import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './i18n';

// Pages
import HomePage from './pages/HomePage';
import SkillsPage from './pages/SkillsPage';
import MissionsPage from './pages/MissionsPage';
import EmployersPage from './pages/EmployersPage';
import CertificationsPage from './pages/CertificationsPage';
import AIProjectsPage from './pages/AIProjectsPage';
import ContactPage from './pages/ContactPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/skills" element={<SkillsPage />} />
          <Route path="/missions" element={<MissionsPage />} />
          <Route path="/employers" element={<EmployersPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/projects" element={<AIProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
